import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['Ends after a single night', 'Promises “zero prep” and leaves you to find out what that means', 'Doesn’t say if it works on your VTT', 'Made for hobby tables, not for people who are paying', 'A video you watch instead of a session you run'];
const withIt = ['A full year of sessions, in order: 57 Run Sheets', 'A one-page Run Sheet you read in about 20 minutes', 'Notes for your VTT and for in-person play on every session', 'Cliffhanger and re-booking hooks built into every ending', 'One payment: no subscription, no course to sit through'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-paper" data-id="element-327" data-mp="2d8snpuqgd64f">
      <div className="max-w-4xl mx-auto px-5 py-16 sm:py-20" data-id="element-328" data-mp="2d6pqapmz0apo">
        <div className="text-center" data-id="element-329" data-mp="30xbxyft2bsz5">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold-deep" data-id="element-330" data-mp="30wacriic1q3p">
            Why this isn&apos;t another one-shot bundle
          </p>
          <h2 id="vs-heading" className="mt-3 font-display font-semibold text-plum text-3xl sm:text-5xl" data-id="element-331" data-mp="1tg4t6b9l3fni">
            Prep-less promises vs{' '}
            <span className="text-coral-deep" data-id="element-332" data-mp="235fydmtco064">a mechanism you can see</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-333" data-mp="1ydxyz36z67n9">
            Most things for paid GMs are a bundle of one-shots that ends after
            one night, or a course about the business. Neither one hands you
            tonight’s session, and neither one hands you the next 52 weeks.
          </p>
        </div>

        {/* Two columns at every width — never stacks */}
        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-3xl border border-cream-dark" data-id="element-334" data-mp="2h5799eokl0fw">
          <div className="bg-cream px-3.5 py-4 sm:p-6" data-id="element-335" data-mp="rprex5fb1ja2">
            <h3 className="font-display text-sm font-semibold text-ink-soft sm:text-lg" data-id="element-336" data-mp="rq9g8ggtqnou">
              A one-shot bundle or a business course
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-337" data-mp="2mtxsqcfw6kn1">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-ink-soft sm:text-sm" data-id="element-338" data-mp="2rrqy539dfam9">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-coral/15" data-id="element-339" data-mp="30sxe9b83yjez">
                    <XIcon className="h-2.5 w-2.5 text-coral-deep" aria-hidden="true" data-id="element-340" data-mp="35sjttrbesbqy" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-plum px-3.5 py-4 text-white sm:p-6" data-id="element-341" data-mp="3fk7dv75myqie">
            <h3 className="font-display text-sm font-semibold text-gold sm:text-lg" data-id="element-342" data-mp="3jiwzfn0tved4">
              Paid Table Ready
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-343" data-mp="3ogorqi5dx2hu">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-medium leading-snug sm:text-sm" data-id="element-344" data-mp="3tfi7yic237lp">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-345" data-mp="2gak7dvcm51f">
                    <CheckIcon className="h-2.5 w-2.5 text-gold-hover" aria-hidden="true" data-id="element-346" data-mp="3tnn3byfsksjz" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}